<template>
  <kd-layout-fixed-bottom-button class="approval-leave-list-page with-two-btns">
    <template #footer>
      <kd-button v-if="!isUnderBatchProcess" @click="showPopupMenu = true">操作</kd-button>
      <!-- <kd-button v-if="!isUnderBatchProcess" @click="startBatchHandle">批量处理</kd-button>
      <kd-button v-if="isUnderBatchProcess" type="secondary rejectAll" @click="batchRejectAllHandle"
        >全部拒绝</kd-button
      >
      <kd-button v-if="isUnderBatchProcess" @click="batchPassAllHandle">全部通过</kd-button> -->
    </template>
    <search-bar
      :clazzs="clazzs"
      :batchProcessQuery="batchProcessQuery"
      :typeOptions="typeOptions"
      @query="batchQueryHandle"
    ></search-bar>
    <kd-tab-bar type="switch" :value="tab" :items-data="tabItems" @change="switchTab" v-if="!isUnderBatchProcess">
      <template #append>
        <div class="append" v-if="unProcessLeaves">{{ unProcessLeaves }}</div>
      </template>
    </kd-tab-bar>

    <div
      v-if="mapData.length > 0"
      class="data-list"
      v-infinite-scroll="fetchStudentLeaves"
      infinite-scroll-disabled="noMoreData"
      infinite-scroll-distance="10"
    >
      <apply-leave-record-card-comp
        @click="itemClickHandle"
        v-for="(info, index) in mapData"
        :showChoose="isUnderBatchProcess"
        :key="index"
        :item="info"
      >
        <template #title>
          <div class="title">
            {{ info.title }}
          </div>
        </template>
      </apply-leave-record-card-comp>
    </div>

    <img
      class="empty"
      :width="$px(105)"
      :height="$px(125)"
      src="./assets/img_empty@2x.png"
      v-if="mapData.length === 0"
    />
    <kd-popup :visible.sync="showPopupMenu" :hideTitle="true">
      <template v-if="isUnProcess">
        <div @click="handelApproveAll">全部通过</div>
        <div @click="handleRejectAll" class="danger">全部拒绝</div>
      </template>
      <div v-if="!$p.Teacher.isCollegeTeacher" @click="navToCreateRecord">登记学生请假</div>
      <div @click="$routerHelper.navigateToApprovalLeaveSetting()">请假设置</div>
      <div @click="showPopupMenu = false">取消</div>
    </kd-popup>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { BasePage, Component, ApplyLeaveRecordCardComp } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdTabBar, KdButton, KdPopup, KDMessageBox, KDPrompt } from 'kuaidong-ui'
import { DateWrapper, ClazzWrapper, BrowserUtil, ArrayUtil } from 'kuaidong-lib'
import { Clazz, StudentLeave } from 'kuaidong-model'
import { AApprovalLeave, AClazz } from 'kuaidong-api'
import { IStudentLeaveRecordItem } from 'kuaidong-model/src/approvalLeave'
import { Watch } from 'vue-property-decorator'
import SearchBar from './components/_SearchBar.vue'

@Component({
  components: {
    ApplyLeaveRecordCardComp,
    KdLayoutFixedBottomButton,
    KdTabBar,
    KdButton,
    KdPopup,
    SearchBar,
  },
})
export default class ApprovalLeaveListPage extends BasePage {
  unProcessLeaves: number | null = null
  tab = '未处理'
  tabItems = ['未处理', '已处理'].map((item) => {
    return {
      name: item,
      label: item,
    }
  })

  studentLeaves: IStudentLeaveRecordItem[] = []

  isUnderBatchProcess = false // 当前是否批量处理

  batchProcessQuery: {
    keyword: string
    class_ids: string[]
    leave_type: string
    date: string
    start_time?: Date
    end_time?: Date
  } = {
    keyword: '',
    class_ids: [],
    leave_type: '',
    date: 'last_1_month',
  }
  checkedIds: string[] = []
  showPopupMenu = false

  clazzs: Clazz[] = []

  typeOptions: { label: StudentLeave; value: string }[] = [
    { label: StudentLeave.sick, value: 'sick' },
    { label: StudentLeave.personal, value: 'personal' },
    { label: StudentLeave.other, value: 'other' },
  ]

  get mapData() {
    let studentLeaves = this.studentLeaves
    // if (this.isUnderBatchProcess) {
    //   if (this.batchProcessQuery.keyword) {
    //     studentLeaves = studentLeaves.filter((x) => {
    //       return (
    //         x.student.nick_name.includes(this.batchProcessQuery.keyword) ||
    //         (x.student.full_name && x.student.full_name.includes(this.batchProcessQuery.keyword)) ||
    //         (x.student.note_name && x.student.note_name.includes(this.batchProcessQuery.keyword)) ||
    //         (x.student.student_no && x.student.student_no.includes(this.batchProcessQuery.keyword)) ||
    //         (x.student.school_roll_no && x.student.school_roll_no.includes(this.batchProcessQuery.keyword))
    //       )
    //     })
    //   }
    //   if (this.batchProcessQuery.leave_type) {
    //     studentLeaves = studentLeaves.filter((x) => x.type === this.batchProcessQuery.leave_type)
    //   }
    //   if (this.batchProcessQuery.class_ids) {
    //     studentLeaves = studentLeaves.filter((x) => `${x.clazz.id}` === this.batchProcessQuery.class_ids)
    //   }
    // }
    return studentLeaves.map((item) => {
      return {
        ...item,
        // checked: this.checkedIds.includes(item.id),
        title: this._show_student_name(item.student),
        status: item.status,
        items: [
          {
            label: '所在班级',
            value: new ClazzWrapper(item.clazz).universityName,
          },
          {
            label: '请假类型',
            value: this.typeOptions.find((t) => t.value === item.type)!.label,
          },
          {
            label: '请假时间',
            value: `${new DateWrapper(item.start_time).showDateStr} ~  ${new DateWrapper(item.end_time).showDateStr}`,
          },
        ],
      }
    })
  }

  get isUnProcess() {
    return '未处理' === this.tab
  }

  get isProcess() {
    return '已处理' === this.tab
  }

  switchTab(item: string) {
    this.tab = item
  }

  offset = 0
  limit = 10
  noMoreData = true

  async created() {
    await this.fetchStudentLeaves()
    this.clazzs = await AClazz.allMine()
    await this.$nextTick()
    BrowserUtil.fixIosWhiteScreenBug()
  }

  async fetchStudentLeaves() {
    const params: any = {
      ...this.batchProcessQuery,
      offset: this.offset,
      limit: this.limit,
    }
    if (this.batchProcessQuery.date === 'custom') {
      params.start_time = this.batchProcessQuery.start_time?.toISOString()
      params.end_time = this.batchProcessQuery.end_time?.toISOString()
    }
    const res = await AApprovalLeave.studentLeaveList(this.isProcess, params)
    this.studentLeaves = [...this.studentLeaves, ...res.items]
    this.noMoreData = this.studentLeaves.length >= res.count
    if (this.isUnProcess) {
      this.unProcessLeaves = res.count
    }
  }

  refreshStudentLeaves() {
    this.offset = 0
    this.studentLeaves = []
    this.fetchStudentLeaves()
  }

  itemClickHandle(item: any) {
    if (this.isUnderBatchProcess) {
      if (this.checkedIds.includes(item.id)) {
        ArrayUtil.remove(this.checkedIds, item.id)
      } else {
        this.checkedIds.push(item.id)
      }
    } else {
      this.$router.push({
        name: 'ask_for_leave_detail',
        query: {
          item: JSON.stringify(item),
        },
      })
    }
  }

  navToCreateRecord() {
    this.$router.push({
      name: 'create_leave_record',
    })
  }

  @Watch('tab')
  updateStudentLeaves() {
    this.refreshStudentLeaves()
  }

  // 开启批量处理
  startBatchHandle() {
    this.isUnderBatchProcess = true
    this.checkedIds = []
    // this.batchProcessQuery = {
    //   date: 'last_1_month',
    //   class_ids: '',
    //   keyword: '',
    //   leave_type: '',
    // }
  }

  async handelApproveAll() {
    const ok = await KDMessageBox.confirm('确认同意所有请假吗？', '', {
      confirmButtonText: '确认同意',
    })
    if (!ok) {
      return
    }
    try {
      const params: any = {
        ...this.batchProcessQuery,
      }
      if (this.batchProcessQuery.date === 'custom') {
        params.start_time = this.batchProcessQuery.start_time?.toISOString()
        params.end_time = this.batchProcessQuery.end_time?.toISOString()
      }
      await AApprovalLeave.postApproveAllStudentLeaves(params)
      await this.refreshStudentLeaves()
      this.toast('全部通过完成！')
    } catch (error) {
      this.toast(error.text || '操作失败')
    } finally {
      this.showPopupMenu = false
    }
  }

  async handleRejectAll() {
    const reason = await KDPrompt.show({
      title: '确认拒绝所有请假吗？',
      confirmButtonText: '确认拒绝',
      confirmButtonType: 'danger',
      placeholder: '请填写审批意见（非必填）',
      required: false,
      value: '',
    })
    if (reason === null) {
      return
    }
    try {
      const params: any = {
        ...this.batchProcessQuery,
        reason,
      }
      if (this.batchProcessQuery.date === 'custom') {
        params.start_time = this.batchProcessQuery.start_time?.toISOString()
        params.end_time = this.batchProcessQuery.end_time?.toISOString()
      }
      await AApprovalLeave.postRejectAllStudentLeaves(params)
      await this.refreshStudentLeaves()
      this.toast('全部拒绝完成！')
    } catch (error) {
      this.toast(error.text || '操作失败')
    } finally {
      this.showPopupMenu = false
    }
  }

  batchQueryHandle(query: any) {
    this.batchProcessQuery = { ...query }
    this.refreshStudentLeaves()
  }
}
</script>
<style lang="less">
.approval-leave-list-page {
  height: 100%;
  box-sizing: border-box;

  > .kd-layout-fixed-bottom__main {
    height: 100%;
    display: flex;
    flex-direction: column;

    > .kd-tab-bar {
      padding-top: 20px;
      padding-bottom: 16px;
      position: relative;
      > .kd-tab-bar__append {
        position: absolute;
        top: 20px;
        left: 122px;

        padding: 2px 4px;
        background: #f24b53;
        border: 1px solid #ffffff;
        border-radius: 50%;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #ffffff;
      }
    }
    .data-list {
      flex: 1;
      overflow-y: scroll;
    }

    > .apply-leave-record-card-comp {
      > .left {
        flex: 1;
        > .items {
          > .item {
            text-align: left;
            align-items: start;
          }
        }
      }

      > .right {
        flex: none;
      }
    }

    > .empty {
      margin: 70px auto 0;
    }
  }
  .kd-layout-fixed-bottom__footer {
    > .kd-button.rejectAll {
      color: #f1592e;
      border: 1px solid #f1592e !important;
    }
  }
  .kd-popup {
    .kd-popup__content {
      padding: 16px 24px;

      > div {
        color: #2d2f33;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        padding: 14px 0;
        &:last-child {
          color: #8f8f8f;
          border-top: 8px solid #f4f5f7;
        }
      }

      .danger {
        color: #f24b53;
      }
    }
  }
}
</style>
